<template>
  <div id="my-music-page">
    <AddTrackForm class="c-max-w" @uploaded="onTrackUploaded" />
    <MyMusic class="c-max-w" ref="myMusic" />
  </div>
</template>

<script>
import AddTrackForm from '@/components/mymusic/AddTrackForm.vue';
import MyMusic from '@/components/mymusic/MyMusic.vue';

export default {
  name: 'MyMusicPage',
  components: {
    AddTrackForm,
    MyMusic,
  },
  metaInfo: {
    title: 'My Music',
  },
  methods: {
    onTrackUploaded() {
      this.$refs.myMusic?.getUploads();
    },
  },
};
</script>
